export { default } from "./PlayerNewsList";
